import React from 'react'
import { Link } from 'react-router-dom'

const WhatsNewList = ({ whatsNewItems }) => {
    return (
        <div id="blog-listing" className="col-section col-no-margin">
            {whatsNewItems.map(whatsNewItem => {
                const {
                    fields: {
                        title,
                        summaryText,
                        slug,
                        publishedDate,
                        category: {
                            fields: { name }
                        }
                    }
                } = whatsNewItem

                // for clarity during debugging
                const categoryName = name

                return (
                    <div key={slug} className="col-xs-12 col-md-6">
                        <Link to={`/whatsnew/${slug}`} className="border-box">
                            <p className="blog-date">
                                {categoryName} | {publishedDate}
                            </p>
                            <h2>{title}</h2>
                            <p>{summaryText}</p>
                            <span className="more-link">Learn More</span>
                        </Link>
                    </div>
                )
            })}
        </div>
    )
}

export default WhatsNewList
